import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { HttpAccessInterceptor } from './interceptors/http-access.interceptor';
import { EnsureModuleLoadedOnceGuard } from './guards/ensure-loaded-once.guard';
import { NgModule, Optional, SkipSelf, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
import { OktaConfig } from '@okta/okta-angular/src/okta/models/okta.config';
import { GlobalErrorHandler } from './handlers/global-error.handler';

export const RRSM_OKTA_CONFIG: OktaConfig = {
  issuer: environment.oktaIssuer,
  clientId: environment.oktaClientId,
  redirectUri: environment.redirectUri,
  scope: environment.oktaScope,
};

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    OktaAuthModule,
  ],
  providers: [
    {
      provide: OKTA_CONFIG,
      useValue: RRSM_OKTA_CONFIG
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpAccessInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    }
  ]
})
export class CoreModule extends EnsureModuleLoadedOnceGuard {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    super(parentModule);
  }
}
